import {MapAnnouncement} from "./MapAnnouncement";

export class UserEnter extends MapAnnouncement {

    private readonly user_id;

    constructor(map_id: string, user_id: string) {
        super(map_id, 'enter', {user_id: user_id});
        this.user_id = user_id;
    }

    get UserId() {
        return this.user_id;
    }

    static fromRaw(map_id: string, value: any): UserEnter {
        if (!value.user_id || typeof value.user_id !== 'string') {
            throw new Error("invalid user_id");
        }
        const user_id = value.user_id;

        return new UserEnter(map_id, user_id);
    }

}
